export const addedToBasket = 'addedToBasket';
export const basketStep = 'basketContent';
export const registerStep = 'registerContent';
export const paymentProviderStep = 'paymentProviderContent';
export const subBookedStep = 'subBookedContent';
export const subAlreadyBookedStep = 'subAlreadyBookedContent';
export const subContentStep = 'subContent';
